import SpinnerOverlay from './SpinnerOverlay';

export default SpinnerOverlay;
